export default class JsonFormatter {
  private jsonString!: boolean
  private toJSON!: Function

  public apply () {
    this.jsonString = true

    if (typeof this.toJSON === 'function') {
      delete this.toJSON
    }

    const jsonValue = JSON.stringify(this)

    delete this.jsonString
    this.toJSON = JsonFormatter.apply

    const returnObject = JSON.parse(jsonValue)
    delete returnObject.jsonString

    for (const key in returnObject) {
      if (returnObject.hasOwnProperty(key) && key.indexOf('_') === 0) {
        delete returnObject[key]
      }
    }

    return returnObject
  }
}
